import { createApiClient } from './client'
import type {
  CreateTripCrewMessageDto,
  ListTripCrewMessagesParams,
  TripChatReadState,
  TripCrewMessage,
  UpdateTripCrewMessageDto,
} from './types'

export class TripChatApi {
  private apiClient: ReturnType<typeof createApiClient>

  constructor(getAuthToken: () => Promise<string | null>) {
    this.apiClient = createApiClient(getAuthToken)
  }

  async listMessages(tripId: string, params?: ListTripCrewMessagesParams): Promise<TripCrewMessage[]> {
    const response = await this.apiClient.get<{ success: boolean; data: TripCrewMessage[] }>(
      `/trips/${tripId}/chat`,
      params
    )
    return response.data
  }

  async sendMessage(tripId: string, payload: CreateTripCrewMessageDto): Promise<TripCrewMessage> {
    const response = await this.apiClient.post<{ success: boolean; data: TripCrewMessage }>(
      `/trips/${tripId}/chat`,
      payload
    )
    return response.data
  }

  async updateMessage(tripId: string, messageId: string, payload: UpdateTripCrewMessageDto): Promise<TripCrewMessage> {
    const response = await this.apiClient.patch<{ success: boolean; data: TripCrewMessage }>(
      `/trips/${tripId}/chat/${messageId}`,
      payload
    )
    return response.data
  }

  async deleteMessage(tripId: string, messageId: string): Promise<void> {
    await this.apiClient.delete<{ success: boolean }>(`/trips/${tripId}/chat/${messageId}`)
  }

  async markRead(tripId: string): Promise<TripChatReadState> {
    const response = await this.apiClient.post<{ success: boolean; data: TripChatReadState }>(
      `/trips/${tripId}/chat/read`
    )
    return response.data
  }

  async listReadStates(tripId: string): Promise<TripChatReadState[]> {
    const response = await this.apiClient.get<{ success: boolean; data: TripChatReadState[] }>(
      `/trips/${tripId}/chat/read`
    )
    return response.data
  }
}
